import React from "react";
import FreelancerLineItemInView from "../Domain/FreelancerLineItemInView";
import FreelancerLineItemService from "../Services/FreelancerLineItemService";
import TabOfDataTable from "./DataTable/TabOfDataTable";

class ShowFreelancerLineItemsComponent extends React.Component {
  static defaultProps = {
    freelancerInvoiceId: null,
  };

  render() {
    if (!this.props.freelancerInvoiceId) return <div>There is no data here.</div>;
    return (
      <TabOfDataTable
        type={FreelancerLineItemInView}
        serviceFunction={() => FreelancerLineItemService.GetLineItemListByInvoiceId(this.props.freelancerInvoiceId)}
        convertDBItemsFunction={FreelancerLineItemService.ConvertDBFreelancerLineItem}
        numberOfElementsOnAPage={9999}
        errorCode="SFLIC22"
      />
    );
  }
}

export default ShowFreelancerLineItemsComponent;
